import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _sortBy from 'lodash/sortBy';

import useClassroomDownloadableCourseAssets from 'Domain/Classroom/ClassroomDownloadableCourseAssets';

import DownloadableContentView from './DownloadableContent.view';

const sortTitleAlphabetically = (array = []) => {
  const result = _sortBy(array, ['title']);
  return result;
};

const DownloadableContent = ({ relevantMaterials, onDownloadClick }) => {
  const { data, loading } = useClassroomDownloadableCourseAssets();
  const allMaterials = useMemo(() => {
    const allContentData = data?.classroomDownloadableCourseAssets ?? [];
    return allContentData.filter((content) =>
      relevantMaterials.every((material) => content.id !== material.id)
    );
  }, [data, relevantMaterials]);

  return (
    <DownloadableContentView
      loading={loading}
      allMaterials={allMaterials}
      relevantMaterials={sortTitleAlphabetically(relevantMaterials)}
      onDownloadClick={onDownloadClick}
    />
  );
};

DownloadableContent.propTypes = {
  relevantMaterials: PropTypes.arrayOf(PropTypes.object),
  onDownloadClick: PropTypes.func,
};

DownloadableContent.defaultProps = {
  relevantMaterials: [],
  onDownloadClick: () => {},
};

export default DownloadableContent;
